import moment from 'moment';
import utils from '../../services/utils';
import courseAPI from '../../services/course';
import courseType from '../../utils/Constants/courseType.constants';
import axiosApi from '../../services/inteceptor';

const API_USER_INFO = `${utils.svcUrl()}user-info`;
const API_COURSE = `${utils.svcUrl()}course`;

const initialState = {
  courses: [],
  segmentOnly: [],
  coursesWithDetails: [],
  fetchCourseLoader: false,
  createCourseLoader: false,
  memberAddLoader: false,
  removeMemberLoader: false,
  inviteMemberModal: false,
  updateCourseLoader: false,
  refreshCourseLoader: false,
  courseDetails: {},
  totalCourses: 0,
};

const mutations = {
  SET_COURSES(state, payload) {
    state.courses = payload;
  },
  SET_COURSES_WITH_DETAILS(state, payload) {
    state.coursesWithDetails = payload;
  },
  SET_COURSE_COUNT(state, payload) {
    state.totalCourses = payload || 0;
  },
  SET_COURSE_DETAILS(state, payload) {
    state.courseDetails = payload;
  },
  SET_SEGMENT(state, payload) {
    state.segmentOnly = payload.filter(item => item.type === 'segment');
  },
  FETCH_LOADER(state, status) {
    state.fetchCourseLoader = status;
  },
  CREATE_COURSE_LOADER(state, status) {
    state.createCourseLoader = status;
  },
  REFRESH_COURSE_LOADER(state, status) {
    state.refreshCourseLoader = status;
  },
  ADD_MEMBER_LOADER(state, status) {
    state.memberAddLoader = status;
  },
  SET_INVITE_MODAL(state, status) {
    state.inviteMemberModal = status;
  },
  UPDATE_COURSE_LOADER(state, status) {
    state.updateCourseLoader = status;
  },
};

const actions = {
  fetchCoursesList: async ({ commit, rootState }, payload) => {
    const { userId = rootState?.user?.uid } = payload;
    try {
      commit('FETCH_LOADER', true);
      console.log(userId, 'userId');
      const response = await axiosApi.get(`${API_COURSE}/getall/courses/${userId}`);
      console.log(response);
      commit('SET_COURSES', response?.data?.courses);
      commit('SET_SEGMENT', response?.data?.courses);
      commit('FETCH_LOADER', false);
    } catch (error) {
      console.log(error);
      commit('FETCH_LOADER', false);
      commit('SET_COURSES', []);
      throw Error(error?.response?.data?.message);
    }
  },
  fetchSegmentList: async ({ commit, rootState }, payload) => {
    const { userId = rootState?.user?.uid, type = 'segment' } = payload;
    try {
      commit('FETCH_LOADER', true);
      const response = await axiosApi.get(
        `${API_COURSE}/getall/courses/${userId}?coursetype=${type}`,
      );
      commit('SET_SEGMENT', response?.courses);
      commit('FETCH_LOADER', false);
    } catch (error) {
      console.log(error);
      commit('FETCH_LOADER', false);
      commit('SET_COURSES', []);
      throw Error(error?.response?.data?.message);
    }
  },
  fetchCoursesListWithDetails: async ({ commit, rootState, state }, payload) => {
    const {
      userId = rootState?.user?.uid,
      limit = 400,
      offset = state?.coursesWithDetails?.length || 0,
    } = payload;
    try {
      const response = await axiosApi.get(
        `${API_COURSE}/getall/projects/${userId}?limit=${limit}&offset=${offset}`,
      );
      commit('SET_COURSES_WITH_DETAILS', response?.data?.courses);
      commit('SET_COURSE_COUNT', response?.data?.total);
    } catch (error) {
      console.log(error);
      commit('SET_COURSES_WITH_DETAILS', []);
      throw Error(error?.response?.data?.message);
    }
  },
  fetchCourse: async ({ commit }, courseId) => {
    try {
      const response = await courseAPI.getCourse(courseId);
      commit('SET_COURSE_DETAILS', response?.course);
      return response?.course;
    } catch (error) {
      commit('SET_COURSE_DETAILS', {});
      console.log(error, error?.response);
      throw Error(error?.response?.data?.message);
    }
  },
  enrollMembersToCourse: async ({ commit }, payload) => {
    try {
      commit('ADD_MEMBER_LOADER', true);
      const response = await courseAPI.enrolllStudentInSegment(payload);
      commit('ADD_MEMBER_LOADER', false);
      return response;
    } catch (error) {
      console.log(error);
      commit('ADD_MEMBER_LOADER', false);
    }
    return null;
  },
  removeMemberFromCourse: async ({ commit }, payload) => {
    try {
      commit('ADD_MEMBER_LOADER', true);
      const response = await axiosApi.post(`${API_USER_INFO}/remove-student`, payload);
      return response;
    } catch (error) {
      console.log(error);
    }
    return null;
  },
  removeMemberByProviderId: async ({ commit }, payload) => {
    try {
      commit('ADD_MEMBER_LOADER', true);
      const response = await axiosApi.delete(`${API_USER_INFO}/remove-student/byProviderId`, {
        data: payload,
      });
      console.log(response?.data);
      return response?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  deleteCourse: async (_, payload) => {
    try {
      console.log(payload, '/remove-all');
      const response = await axiosApi.delete(
        `${API_COURSE}/delete/all?courseId=${payload.courseId}&removeSubmissions=${payload?.removeSubmissions}`,
      );
      return response.data;
    } catch (error) {
      console.log(error?.response?.data);
      throw error;
    }
  },
  inviteMemberToCourse: async ({ rootState }, payload) => {
    try {
      const {
        username,
        courseId,
        creatorId = rootState?.user?.uid,
        message = '',
        Type = 'username',
        enroll = true,
        sendnotification = false,
        Comments = false,
        Retweets = false,
        Likes = false,
        isPipelineUser = false,
      } = payload;

      const response = await axiosApi.post(`${API_USER_INFO}/inviteUser`, {
        username,
        courseId,
        creatorId,
        message,
        Type,
        enroll,
        sendnotification,
        Comments,
        Retweets,
        Likes,
        isPipelineUser,
        pipelineCurrentMember: rootState.pipeline.pipelineStudentsCount,
      });
      return response;
    } catch (error) {
      console.log(error, error?.response);
      throw Error(error?.response?.data?.message);
    }
    // return null;
  },
  createCourse: async ({ commit, rootState }, payload) => {
    try {
      const {
        title = 'new segment',
        userId = rootState?.user?.uid,
        type = courseType.SEGMENT,
        publishDateTime = moment()
          .subtract(30, 'days')
          .toDate(),
        description = '',
        price = 0,
        maxStudents = '',
        linear = false,
        scheduled = false,
        Frequency = false,
        frequency = false,
        publish = false,
        currency = 'USD',
        purchaseParityEnabled = false,
        medium = false,
        setStudentLimit = false,
        sharingtips = false,
        Enablehashtag = false,
        Threadseries = false,
        showBackground = false,
        showCheck = false,
        showFeedback = false,
        showParticipate = false,
        showTakeaway = false,
        AllowsubmissionviaDM = false,
        fromQuery = false,
        isConfirm = false,
        isDynamicSegment = false,
        filterList = [],
      } = payload;
      commit('CREATE_COURSE_LOADER', true);
      const response = await courseAPI.createCourse({
        title,
        userId,
        type,
        publishDateTime,
        description,
        price,
        maxStudents,
        linear,
        scheduled,
        Frequency,
        frequency,
        publish,
        currency,
        purchaseParityEnabled,
        medium,
        setStudentLimit,
        sharingtips,
        Enablehashtag,
        Threadseries,
        showBackground,
        showCheck,
        showFeedback,
        showParticipate,
        showTakeaway,
        AllowsubmissionviaDM,
        fromQuery,
        isConfirm,
        isDynamicSegment,
        filterList,
      });
      commit('CREATE_COURSE_LOADER', false);
      return response;
    } catch (error) {
      console.log(error);
      commit('CREATE_COURSE_LOADER', false);
    }
    return null;
  },
  refreshCourse: async ({ commit }, { courseId }) => {
    try {
      commit('REFRESH_COURSE_LOADER', true);

      const response = await axiosApi.get(`${API_COURSE}/refresh/segment/${courseId}`);
      commit('REFRESH_COURSE_LOADER', false);
      return response?.data;
    } catch (error) {
      console.log(error);
      commit('REFRESH_COURSE_LOADER', false);
      throw Error(error?.response?.data?.message);
    }
  },
  updateCourse: async ({ commit, rootState }, { payload, courseId }) => {
    try {
      const {
        title = 'new segment',
        userId = rootState?.user?.uid,
        type = courseType.SEGMENT,
        publishDateTime = moment()
          .subtract(30, 'days')
          .toDate(),
        description = '',
        price = 0,
        maxStudents = '',
        linear = false,
        scheduled = false,
        Frequency = false,
        frequency = false,
        publish = false,
        currency = 'USD',
        purchaseParityEnabled = false,
        medium = false,
        setStudentLimit = false,
        sharingtips = false,
        Enablehashtag = false,
        Threadseries = false,
        showBackground = false,
        showCheck = false,
        showFeedback = false,
        showParticipate = false,
        showTakeaway = false,
        AllowsubmissionviaDM = false,
        fromQuery = false,
        isDynamicSegment = false,
        filterList = [],
      } = payload;
      commit('UPDATE_COURSE_LOADER', true);
      const response = await courseAPI.updateCourse(courseId, {
        title,
        userId,
        type,
        publishDateTime,
        description,
        price,
        maxStudents,
        linear,
        scheduled,
        Frequency,
        frequency,
        publish,
        currency,
        purchaseParityEnabled,
        medium,
        setStudentLimit,
        sharingtips,
        Enablehashtag,
        Threadseries,
        showBackground,
        showCheck,
        showFeedback,
        showParticipate,
        showTakeaway,
        AllowsubmissionviaDM,
        fromQuery,
        isDynamicSegment,
        filterList,
      });
      commit('UPDATE_COURSE_LOADER', false);
      return response?.data;
    } catch (error) {
      console.log(error);
      commit('UPDATE_COURSE_LOADER', false);
      throw Error(error?.response?.data?.message);
    }
  },
};

export default {
  state: initialState,
  mutations,
  actions,
};
